export const OPEN_ADVANCED_VIEWER_ACTION = 'VIEWER.OPEN_ADVANCED_VIEWER_ACTION';
export const OPEN_BASIC_VIEWER_ACTION = 'VIEWER.OPEN_BASIC_VIEWER_ACTION';

export const ON_CHANGE_SELECTED_VERSION_ACTION = 'VIEWER.ON_CHANGE_SELECTED_VERSION_ACTION';
export const ON_CHANGE_SELECTED_VERSION_TRANSACTION =
	'VIEWER.ON_CHANGE_SELECTED_VERSION_TRANSACTION';
export const ON_CLICK_VERSION_COMMAND_ACTION = 'VIEWER.ON_CLICK_VERSION_COMMAND_ACTION';
export const ON_CLICK_PANEL_COMMAND_ACTION = 'VIEWER.ON_CLICK_PANEL_COMMAND_ACTION';
export const COMPLETE_BRANCH_TRANSACTION = 'VIEWER.COMPLETE_BRANCH_TRANSACTION';
export const SET_VERSION_CONTENTS_ACTION = 'VIEWER.SET_VERSION_CONTENTS_ACTION';
export const SET_VERSION_CONTENT_ACTION = 'VIEWER.SET_VERSION_CONTENT_ACTION';
export const ON_CHANGE_PANEL_DISABLED_ACTION = 'VIEWER.ON_CHANGE_PANEL_DISABLED_ACTION';
export const ON_CHILD_PANEL_CLOSED_TRANSACTION = 'VIEWER.ON_CHILD_PANEL_CLOSED_TRANSACTION';

export const SET_CHAT_WITH_DOCUMENT_SESSION_ACTION = 'VIEWER.SET_CHAT_WITH_DOCUMENT_SESSION_ACTION';
